import React from 'react'
import { createContext, useState, useEffect, useContext } from "react";
import io from "socket.io-client";
import { useGetProfileQuery } from '../Redux/Apis/authApi';
import { useGetNotificationsQuery } from '../Redux/Apis/notificationsApis';
import { url } from "../Utils/BaseUrl.js";

const SocketContextData = createContext();

export const useSocketContext = () => {
    return useContext(SocketContextData);
};

const SocketContext = ({ children }) => {
    const [socket, setSocket] = useState(null);
    const [onlineUsers, setOnlineUsers] = useState([]);
    const { data } = useGetProfileQuery()
    const [notifications, setNotifications] = useState([])
    const [notificationLimit, setNotificationLimit] = useState(50)
    const { data: notificationsData, isLoading: isLoadingNotifications } = useGetNotificationsQuery({ page: 1, limit: notificationLimit })

    const userId = data?.data?._id

    useEffect(() => {
        if (!userId) return
        const connection = io(url, { withCredentials: true })
        setSocket(connection)
        connection.on("getOnlineUsers", (users) => setOnlineUsers(users))
        connection.on("new-notification", (notification) => {
            setNotifications((prev) => [notification, ...prev])
        })
        return () => {
            connection.close()
            setSocket(null)
        }
    }, [userId])

    useEffect(() => {
        if (notificationsData?.data?.length > 0) {
            setNotifications(notificationsData.data)
        }
    }, [notificationsData])

    const socketData = {
        socket,
        onlineUsers,
        isLoadingNotifications,
        notifications,
        totalNotifications: notificationsData?.pagination?.totalItems,
        setNotificationLimit,
        notificationLimit
    }
    return <SocketContextData.Provider value={socketData}>{children}</SocketContextData.Provider>;
}

export default SocketContext
